module.exports = __webpack_public_path__ + "static/img/effectbannerbg3.57d6c63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/effectbannerbg3.png
// module id = kwkz
// module chunks = 171